// extracted by mini-css-extract-plugin
export default {"mainWrapper":"grade-detail-container_mainWrapper__D6oyK","boxWrapper":"grade-detail-container_boxWrapper__UYkPA","buttonWrapper":"grade-detail-container_buttonWrapper__JcWMl"};